var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToggleTileViewBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5C15.8284 1.5 16.5 2.17157 16.5 3L16.5 6C16.5 6.82843 15.8284 7.5 15 7.5L3 7.5C2.17157 7.5 1.5 6.82843 1.5 6L1.5 3C1.5 2.17157 2.17157 1.5 3 1.5L15 1.5Z",
    stroke: "#7BABF5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15.8284 10.5 16.5 11.1716 16.5 12L16.5 15C16.5 15.8284 15.8284 16.5 15 16.5L12 16.5C11.1716 16.5 10.5 15.8284 10.5 15L10.5 12C10.5 11.1716 11.1716 10.5 12 10.5L15 10.5Z",
    stroke: "#7BABF5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5C6.82843 10.5 7.5 11.1716 7.5 12L7.5 15C7.5 15.8284 6.82843 16.5 6 16.5L3 16.5C2.17157 16.5 1.5 15.8284 1.5 15L1.5 12C1.5 11.1716 2.17157 10.5 3 10.5L6 10.5Z",
    stroke: "#7BABF5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToggleTileViewBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/toggle-tile-view-blue.b52f0faf70ab09922113a95b7cd0b4e2.svg";